<template>
  <div class="resman-left-nav" v-click-outside="{
        handler: clearNavRailActive,
        include: include,
      }">
    <v-navigation-drawer app
                         clipped
                         permanent

                         mini-variant
                         mini-variant-width="112"
                         class="resman-left-nav-drawer">
      <v-list dense nav subheader>
        <v-list-item-group v-model="selectedItem">

          <v-subheader v-if="isGlobal" class="text-center">GLOBAL</v-subheader>
          <v-list-item link v-if="isGlobal" :to="{ name: 'BulkBudgetCreation' }" exact active-class="currentRoute" class="resman-collapse-left-nav-sub" :value="'BulkBudgetCreation'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">touch_app</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Bulk Budget<br />Creation</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link v-if="isGlobal" :to="{ name: 'BulkCalculationsAssumptions' }" exact active-class="currentRoute" class="resman-collapse-left-nav-sub" :value="'BulkCalculationsAssumptions'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">settings</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Bulk Calc / Assumpt</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link v-if="isGlobal" :to="{ name: 'SettingsSummary' }" exact active-class="currentRoute" class="resman-collapse-left-nav-sub" :value="'SettingsSummary'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">settings</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>View<br />Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader v-if="isTemplates" class="text-center">TEMPLATES</v-subheader>
          <v-list-item link v-if="isTemplates" :to="{ name: 'GLAccountTemplatesLanding' }" exact active-class="currentRoute" class="resman-collapse-left-nav-sub" :value="'GLAccountTemplates'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">touch_app</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>GL Account<br />Template</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link v-if="isTemplates" :to="{ name: 'SettingsTemplatesLanding' }" exact active-class="currentRoute" class="resman-collapse-left-nav-sub" :value="'SettingsTemplates'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">settings</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Settings<br />Template</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-subheader v-if="isBudgets" class="text-center">BUDGETS</v-subheader>
          <v-list-item link v-if="isBudgets" :to="{ name: 'Landing' }" exact active-class="currentRoute" class="resman-collapse-left-nav-sub" :value="'Budgets'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">touch_app</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Browse <br />Budgets</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="budgetIterationId != null"></v-divider>
          <v-subheader v-if="budgetIterationId != null" class="text-center">SELECTED<br />VERSION</v-subheader>
          <v-list-item link v-if="budgetIterationId != null" :to="{ name: 'Settings' }" active-class="currentRoute" :class="['resman-collapse-left-nav-sub']" :value="'Settings'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">settings</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center">Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider v-if="budgetIterationId != null"></v-divider>
          <v-subheader v-if="budgetIterationId != null" class="text-center">MKT RENT &amp;<br />OCCUPANCY</v-subheader>
          <v-list-item link v-if="budgetIterationId != null" :to="{ name: 'MarketRent' }" active-class="currentRoute" :class="['resman-collapse-left-nav-sub']" :value="'MarketRent'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">price_check</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center">Mkt Rent</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link v-if="budgetIterationId != null" :to="{ name: 'Occupancy' }" active-class="currentRoute" :class="['resman-collapse-left-nav-sub']" :value="'Occupancy'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">maps_home_work</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Occupancy</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="leftNavItems.length > 0"></v-divider>
          <v-subheader v-if="leftNavItems.length > 0" class="text-center">GL<br />ACCOUNTS</v-subheader>
          <v-list-item link v-for="item in leftNavItems"
                       :key="item.title" @click="leftNavFlyoutClick(item.title, item.icon, item.subItems)" :class="getClassForGroupParent(item.title, item.subItems)" :value="item.title">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">{{ item.icon }}</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="budgetIterationId != null"></v-divider>
          <v-subheader v-if="budgetIterationId != null" class="text-center">OTHER</v-subheader>
          <v-list-item link v-if="budgetIterationId != null" :to="{ name: 'WorkingDraft' }" active-class="currentRoute" :class="['resman-collapse-left-nav-sub']" :value="'WorkingDraft'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">article</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Working<br />Draft</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link v-if="budgetIterationId != null" :to="{ name: 'Documents' }" active-class="currentRoute" :class="['resman-collapse-left-nav-sub']" :value="'Documents'">
            <v-list-item-content>
              <v-icon class="resman-left-nav-icon">file_present</v-icon>
              <v-list-item-title class="resman-left-nav-title text-center" v-resman-ellipses-title>Documents</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-scroll-x-transition origin="left">
      <left-nav-sub v-if="selectedItem != undefined && leftNavSubItems.length > 0" :parentTitle="leftNavSubParentTitle" :parentIcon="leftNavSubParentIcon" :subItems="leftNavSubItems" :width="leftNavSubWidth" @overlayClicked="clearNavRailActive()"></left-nav-sub>
    </v-scroll-x-transition>
  </div>
</template>

<script>
  import LeftNavSub from '@/components/navigation/left-navigation/LeftNavSub';
  import budgetService from '@/services/budget';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'LeftNav',
    components: {
      LeftNavSub
    },
    data: function () {
      return {
        budgetIterationId: null,
        groupId: null,
        area: '',
        leftNavSubItems: [],
        leftNavSubParentTitle: '',
        leftNavSubParentIcon: '',
        leftNavItems: [],
        selectedItem: '',
        leftNavSubWidth: 265,
        minWidth: 265,
        maxWidth: 400,
      };
    },
    computed: {
      ...mapGetters([]),
      isBudgets() {
        return this.area == 'Budgets';
      },
      isTemplates() {
        return this.area == 'Templates';
      },
      isGlobal() {
        return this.area == 'Global';
      },
    },
    methods: {
      ...mapActions(['changeLoading']),
      leftNavFlyoutClick(title, icon, subItems) {
        this.leftNavSubParentTitle = title;
        this.leftNavSubParentIcon = icon;
        this.leftNavSubItems = subItems;
      },
      clearNavSubItems() {
        this.leftNavSubParentTitle = '';
        this.leftNavSubParentIcon = '';
        this.leftNavSubItems = [];
      },
      clearNavRailActive() {
        this.clearNavSubItems();
        this.selectedItem = '';
      },
      getClassForGroupParent(parentTitle, subItems) {
        var self = this;
        var c = '';
        if (this.selectedItem == parentTitle) {
          c = 'currentFocus ';
        } else {
          c = '';
        }
        if (self.groupId != null && self.groupId != undefined) {
          if (subItems.filter(function (e) { return e.groupId == self.groupId; }).length > 0) {
            c = c + 'currentRoute';
          }
        }
        return c;
      },
      include() {
        return [document.querySelector('.resman-collapse-left-nav-sub')]
      },
      getNavRailItemClassByIsCurrentRoute(itemRouteName) {
        if (this.$route.name == itemRouteName)
          return 'currentRoute';
        else
          return '';
      },
      async loadGroups() {
        // initialize navigation items
        this.changeLoading(true);

        if (this.budgetIterationId != null) {
          let rentalIncomeItem = { title: 'Income', icon: 'attach_money', active: false, subItems: [] };
          let expenseItem = { title: 'Expense', icon: 'receipt_long', active: false, subItems: [] };
          let nonOperatingItem = { title: 'Non - Operating', icon: 'request_page', active: false, subItems: [] };
          let otherItem = { title: 'Other', icon: 'account_balance', active: false, subItems: [] };

          let groups = await budgetService.getBudgetGroups(this.budgetIterationId);
          groups.forEach((g) => {
            switch (g.groupTypeId) {
              case 1:
                rentalIncomeItem.subItems.push({ title: g.name, groupId: g.groupId });
                break;
              case 2:
                expenseItem.subItems.push({ title: g.name, groupId: g.groupId });
                break;
              case 3:
                nonOperatingItem.subItems.push({ title: g.name, groupId: g.groupId });
                break;
              default:
                otherItem.subItems.push({ title: g.name, groupId: g.groupId });
                break;
            }
          });

          this.leftNavItems.push(rentalIncomeItem);
          this.leftNavItems.push(expenseItem);
          if (nonOperatingItem.subItems.length > 0) {

            this.leftNavItems.push(nonOperatingItem);
          }
          if (otherItem.subItems.length > 0) {
            this.leftNavItems.push(otherItem);
          }

          // calculate nav sub width
          var tempwidth = Math.max(0, ...groups.map(s => s.name.length));          
          tempwidth = (tempwidth * 8) + 32;
          if (tempwidth < this.minWidth) {
            tempwidth = this.minWidth;
          } else if (tempwidth > this.maxWidth) {
            tempwidth = this.maxWidth;
          }
          this.leftNavSubWidth = tempwidth;
        } else {
          this.leftNavItems = [];
        }

        this.changeLoading(false);
      },
    },
    async mounted() {
      if (this.$route.params.budgetIterationId != null) {
        this.budgetIterationId = this.$route.params.budgetIterationId;
        this.area = 'Budgets';
        if (this.$route.params.groupId != null) {
          this.groupId = this.$route.params.groupId;
        }
        this.loadGroups();
      }
      else {
        if (this.$route.path.startsWith('/Budgets/')) {
          this.area = 'Budgets';
        }
        else if (this.$route.path.startsWith('/Templates/')) {
          this.area = 'Templates';
        }
        else if (this.$route.path.startsWith('/Global/')) {
          this.area = 'Global';
        }
      }
    },
    watch: {
      async $route(to, from) {
        this.selectedItem = null;
        this.clearNavSubItems();
        // viewing a specific budget, load groups and worksheets
        if (to.params.budgetIterationId != null) {
          let budgetChanged = to.params.budgetIterationId != from.params.budgetIterationId;

          if (budgetChanged) {
            this.budgetIterationId = to.params.budgetIterationId;
            this.loadGroups();
          } else if (to.params.groupId != null) {
            let groupChanged = to.params.groupId != from.params.groupId;

            if (groupChanged) {
              this.groupId = to.params.groupId;
            }
          } else {
            // we're in a budget which didn't change but not a group
            this.groupId = null;
          }
        }
        else {
          this.budgetIterationId = null;
          this.groupId = null;
          this.leftNavItems = [];

          if (to.path.startsWith('/Budgets/')) {
            this.area = 'Budgets';
          }
          else if (to.path.startsWith('/Templates/')) {
            this.area = 'Templates';
          }
          else if (to.path.startsWith('/Global/')) {
            this.area = 'Global';
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .resman-left-nav-drawer .v-subheader {
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 4px;
    justify-content: center;
  }
  .resman-left-nav .resman-left-nav-title {
    white-space: initial !important;
    font-size: 12px;
  }

  .resman-left-nav .currentRoute {
    .resman-left-nav-icon.v-icon {
      color: var(--v-resBlue-darken1) !important;
    }
    .resman-left-nav-title {
      color: var(--v-resBlue-darken1) !important;
    }
  }
  .resman-left-nav .v-list-item:hover {
    background-color: var(--v-resBlue-darken1) !important;
    .resman-left-nav-icon.v-icon {
      color: white !important;
    }
    .resman-left-nav-title {
      color: white !important;
    }
  }
  .resman-left-nav .v-list-item--active::before {
    opacity: 0 !important;
  }
  .resman-left-nav .resman-left-nav-drawer .currentFocus {
    background-color: var(--v-resBlue-darken1) !important;
    .resman-left-nav-icon.v-icon {
      color: white !important;
    }
    .resman-left-nav-title {
      color: white !important;
    }    
  }
</style>
